import { render, staticRenderFns } from "./CProfileDetailForMyPage.vue?vue&type=template&id=1724fca8&"
import script from "./CProfileDetailForMyPage.vue?vue&type=script&lang=ts&"
export * from "./CProfileDetailForMyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports